// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__gFngZ","content":"LoadingAlert_content__1df6s"};